import { render, staticRenderFns } from "./payment_form.vue?vue&type=template&id=60714724&scoped=true"
import script from "./payment_form.vue?vue&type=script&lang=js"
export * from "./payment_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60714724",
  null
  
)

export default component.exports